$(document).ready( function(){
  $('.scroll .scroll-link').on('click', function(e){
    e.preventDefault();
    var target = $(this).attr('href');
    // $(target).addClass('router-link-exact-active');
    $("html, body").animate({ scrollTop: $(target).offset().top - 30 - 50 }, 1200);
  });
  function getCurrent(){};
  // Cache selectors
  var topMenu = $("#nav-block"),
    topMenuHeight = topMenu.outerHeight(),
    // All list items
    menuItems = topMenu.find("a"),
    // Anchors corresponding to menu items
    scrollItems = menuItems.map(function(){
      var item = $($(this).attr("href"));
      if (item.length) { return item; }
    });

    var oldPoint = null;

    setTimeout(() => {
      if(document.documentElement.scrollTop == 0 && !$('#home-section-link').hasClass('active')){
        $('#home-section-link').addClass('active')
      } else if(document.documentElement.scrollTop !== 0) {
        window.scrollTo({
          top: document.documentElement.scrollTop + 1,
          behavior: "smooth"
        })
      }
    }, 300)

// Bind to scroll
  $(window).scroll(function(){
     // Get container scroll position
     var fromTop = $(this).scrollTop()+topMenuHeight;

     // Get id of current scroll item
     var cur = scrollItems.map(function(){
       if ($(this).offset().top < fromTop)
         return this;
     });
     // Get the id of the current element
     cur = cur[cur.length-1];
     var id = cur && cur.length ? cur[0].id : "";

     if(id && id !== 'home-section' && !$('#back-to-top').hasClass('show-button')){
      $('#back-to-top').addClass('show-button')
     } else if(id == 'home-section' && $('#back-to-top').hasClass('show-button')) {
      $('#back-to-top').removeClass('show-button')
     }

     if(!oldPoint) {
      // console.log(id)
      oldPoint = id
      $('#' + id + '-link').addClass('active')
     } else if(oldPoint && id !== oldPoint) {
      $('#' + oldPoint + '-link').removeClass('active')
      oldPoint = id
      $('#' + id + '-link').addClass('active')
     }
  });


  // Header animation
  $(function(){
   var shrinkHeader = 100;
   $(window).scroll(function() {
      var scroll = getCurrentScroll();
      if ( scroll >= shrinkHeader ) {
       $('.header-section').addClass('scrolled-header');
     }
     else {
      $('.header-section').removeClass('scrolled-header');
    }
  });
     function getCurrentScroll() {
      return window.pageYOffset || document.documentElement.scrollTop;
    }
  });

  $('#carouselHomeBanner').on('slide.bs.carousel', function ({from, to}) {
    if(from == 0) {
      if(!$('#firstSlide').hasClass('hide-animation')) {
        $('#firstSlide').addClass('hide-animation')
      }
      $('#secondSlide').removeClass('hide-animation')
    } else {
       $('#secondSlide').addClass('hide-animation')
       $('#firstSlide').removeClass('hide-animation')
    }
  })
});



// WEBPACK FOOTER //
// ./resources/js/scroll.js